import { render } from "./VTour.vue?vue&type=template&id=4cbe42da"
import script from "./VTour.vue?vue&type=script&lang=js"
export * from "./VTour.vue?vue&type=script&lang=js"

import "./VTour.vue?vue&type=style&index=0&id=4cbe42da&lang=scss"
script.render = render

export default script